// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__-rT6p","label":"Section_label__2vtEL","contentWrap":"Section_contentWrap__2DZc8","footer":"Section_footer__3EptO","footerInner":"Section_footerInner___OrSg"};